import React, { useEffect, useState } from 'react';
import iconCheck from '../../assets/images/chacked.svg';
import iconUncheck from '../../assets/images/unchacked.svg';
import plusIcon from '../../assets/images/add-icon-min.svg';
import backArrow from '../../assets/images/arrow.svg';
import { useHistory, useLocation, useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import ConfirmBookingMessage from './ConfirmBookingMessage';
import iconEdit from '../../assets/images/edit.svg'
import { toast } from 'react-toastify';
import {
    Get, Post
} from '../../Api/ApiMethods.js';
import {
    getMyCardsListUrl,
    createSubscriptionBookingUrl,
    validateCvvForBooking,
    confirmBookNewSlotUrl
 } from '../../Routes/ApiRoutes';
import CircularLoader from '../../utils/Loaders/CircularLoader';
import { loadStripe } from '@stripe/stripe-js';
// import { useSearchParams } from 'react-router-dom'


export default function ListCards(props) {
    const token = useSelector((state) => state.auth.isSignedIn);
    const history = useHistory();
    const {id} = useParams();
    const {pathname} = useLocation();
    var pq = pathname.split('/');
    const [cnfrm, setcnfrm] = useState(false);
    const [loader, setLoader] = useState(false);
    const [cardList, setCardList] = useState([]);
    const [selectedCard, setSelectedCard] = useState(null);
    const [cvvError, setCvvError] = useState(null);
    const [btnName, setBtnName] = useState('Add card');

    useEffect(() => {
      fetchCardList();
      if(pathname === '/profile/cardList'){
        setBtnName('Add card')
      }else{
        setBtnName('New Payment')
      }
    },[]);


    useEffect(() => {
      setLoader(true);
      if(props.location.state){
        setLoader(true);
        let cardId = props.location.state.data.cardCreationResponseInDB.id;

        let sendData = {
          "slot_id":pq[pq.length-3],
          "vehicle_id": pq[pq.length-2],
        }
        setLoader(true);
          try {
            Post(confirmBookNewSlotUrl,token, sendData)
            .then(res => {
                if(res.status === 200){
                    console.log(res)
                    setLoader(true);
                    toast.success(res.message);
                    finalizeSubscriptionPlan(res, cardId);
                }
            })
            .catch(error => {
                setLoader(false);
                toast.error(error.error);
            })
          }
          catch (error) {
            setLoader(false);
            toast.error(error.error);
        }
      }
    }, [])
    
    const fetchCardList = () => {
      setLoader(true);
        try {
          Get(getMyCardsListUrl, token)
          .then(res => {
              if(res.status === 200){
                setCardList(res.data.rows);
                res.data.rows.map((item) => {
                  if(item.is_default === true){
                    let vl = {...item}
                    vl['new_cvv'] = '';
                    setSelectedCard(vl);
                  }
                })
                setLoader(false);
              }
          })
          .catch(error => {
              toast.error(error.error);
              setLoader(false);
          })
        }catch (error) {
          toast.error(error.error);
          setLoader(false);
      }
    }

    const handleSelectionCard = (item) => {
      if(! item.is_default){
        let vl = [...cardList]
        
        const objIndex = vl.findIndex(obj => obj.is_default === true);
        if(objIndex !== -1){
          const updatedObj = { ...vl[objIndex], is_default: false};
          const updatedProjects = [...vl.slice(0, objIndex),updatedObj,...vl.slice(objIndex + 1),];

          const newObjIndex = updatedProjects.findIndex(obj => obj.card_id === item.card_id);
          const newUpdatedObj = { ...updatedProjects[newObjIndex], is_default: true};
          const newUpdatedProjects = [...updatedProjects.slice(0, newObjIndex),newUpdatedObj,...updatedProjects.slice(newObjIndex + 1),];

          let ll = {...item}
          ll['new_cvv'] = '';
          setSelectedCard(ll);

          setCardList(newUpdatedProjects);
        }else{
          const newObjIndex = vl.findIndex(obj => obj.card_id === item.card_id);
          const newUpdatedObj = { ...vl[newObjIndex], is_default: true};
          const newUpdatedProjects = [...vl.slice(0, newObjIndex),newUpdatedObj,...vl.slice(newObjIndex + 1),];

          let ll = {...item}
          ll['new_cvv'] = '';
          setSelectedCard(ll);
          console.log('test cvv is => ' + item.cvv)

          setCardList(newUpdatedProjects);
        }
      }
    }

    const handleInputChange = (e) => {
      let vl = {...selectedCard}
      vl['new_cvv'] = e.target.value;
      setSelectedCard(vl);
      if(e.target.value === ''){
          setCvvError('Card cvv is mandatory.')
      }else if(isNaN(e.target.value)){
          setCvvError('Card cvv is a numeric field which is 3 to 4 digit long.')
      }else{
          setCvvError(null);
      }
    }


    const handleSelectedCardPay = () => {
      setLoader(true);
      if(selectedCard.new_cvv === '' && !cvvError){
        toast.error('Please enter cvv.');
        setLoader(false);
      }else{
      let sendData = {
        "card_id":selectedCard.card_id,
        "cvv": selectedCard.new_cvv
        };
        validatingCvv(sendData);
      }
    }

    const validatingCvv = (sendData) => {
      setLoader(true);
        try {
          Post(validateCvvForBooking,token, sendData)
          .then(res => {
              if(res.status === 200){
                  toast.success(res.message);
                  getBookingId();
              }
          })
          .catch(error => {
              setLoader(false);
              toast.error(error.error);
          })
        }catch (error) {
          setLoader(false);
          toast.error(error.error);
      }
    }

    const getBookingId = () => {
      let sendData = {
        "slot_id":pq[pq.length-3],
        "vehicle_id": pq[pq.length-2],
      }
      setLoader(true);
        try {
          Post(confirmBookNewSlotUrl,token, sendData)
          .then(res => {
              if(res.status === 200){
                  toast.success(res.message);
                  finalizeSubscriptionPlan(res, selectedCard.card_id);
              }
          })
          .catch(error => {
              setLoader(false);
              toast.error(error.error);
          })
        }catch (error) {
          setLoader(false);
          toast.error(error.error);
      }
    }

    const finalizeSubscriptionPlan = (getData, cardId) => {
      setLoader(true);
      let sendData = {
        "plan_id": id,
        "card_id": cardId,
        "slot_id": pq[pq.length-3],
        "vehicle_id": pq[pq.length-2],
        "booking_id":getData.data.id
      }
        try {
          Post(createSubscriptionBookingUrl, token, sendData)
          .then(res => {
              if(res.status === 200){
                console.log(res);
                paymentGateway(res);
              }
          })
          .catch(error => {
              toast.error(error.error);
              setLoader(false);
          })
        }catch (error) {
          toast.error(error.error);
          setLoader(false);
      }
    }

    const paymentGateway = async (data) => {
      console.log('data in payment', data)
      try {
          let stripe = await loadStripe("pk_test_51J8n3tItG0j73TexQvYJs5re16dJArg6OpiFsVyY5WkD6N1G1CaIuoEZJ3NHt922uajoXkIiXE4iVM0IzGR7I9gV00BKAM1KkX");
          stripe.confirmCardPayment(data.data)
          .then(async function(result) {
            if (result.error) {
              toast.error(result.error.message);
              console.log(result.error.message);
              setLoader(false);
            } else {
              if (result.paymentIntent.status === 'succeeded') {
                setLoader(false);
                setcnfrm(true);
              }
            }
          });
      } 
      catch (error) {
        setLoader(false);
        toast.error(error.message);
        console.log(error);
      }
    };

    console.log('useselector', useSelector((state) => state.vehicleId))

    return (
        <>
        {loader && <CircularLoader />}
        {cnfrm && <ConfirmBookingMessage />}
         <section class="Notifications-wrapper">
            <div class="container">
              <div class="Notifications">
                <div class="row no-gutters">
                  <div class="col-md-12 col-sm-12 col-12 padding-rt">
                    <div class="generate">
                      <h3><img class="mr-2" src={backArrow} onClick={() => {
                          if(pathname === '/profile/cardList'){
                            history.push(`/profile`)
                          }else{
                            history.push(`/booking/listSubscription/${pq[pq.length-3]}/${pq[pq.length-2]}`)
                          }
                        }} />Saved cards</h3>
                        <p className='text'>{btnName}<img class="mr-2 cursorP" src={plusIcon} onClick={() => {
                          if(pathname === '/profile/cardList'){
                            history.push(`/profile/cardList/addCard`)
                          }else{
                            history.push(`/booking/listCards/addCard/${pq[pq.length-3]}/${pq[pq.length-2]}/${pq[pq.length-1]}`)
                          }
                        }} /></p>

                        {cardList.length > 0 ? cardList.map(item => {
                          return(
                            <div key={item.card_id} class="card-wrapper">
                              <div class="card-info">
                                <div class="media">
                                  {pathname !== '/profile/cardList' &&
                                    <img onClick={() => {
                                      handleSelectionCard(item)
                                    }} src={item.is_default ? iconCheck : iconUncheck} alt="John Doe" class="mr-3" />
                                  }
                                  <div class="media-body">
                                    <h4>{item.card_number && item.card_number.split('').map((i, index)=> {
                                      let lng = item.card_number.length-5;
                                      if(index > lng || index < 4){
                                        return i;
                                        }else{
                                          return '*';
                                      }
                                    })}</h4>
                                    <p>{item.name}</p>
                                    <p>Expires on {item.exp_month && (item.exp_month.toString().length === 1 ? "0"+item.exp_month : item.exp_month) +'/'+ item.exp_year}</p>
                                  </div>
                                  {pathname !== '/profile/cardList' && item.is_default &&
                                    <div class="form-group">
                                      <input className={cvvError && "borderRed"}  onChange={(e) => handleInputChange(e)} type="text" placeholder="CVV" />
                                      {cvvError && <span className='form-error'>{cvvError}</span>}
                                    </div>
                                  }
                                </div>
                              </div>
                                {pathname === '/profile/cardList' &&
                                  <div class="edit-details">
                                    {/* <div class="delete">
                                      <img src={iconDeleta} />
                                      <span>Delete</span>
                                    </div> */}
                                    <div class="edit">
                                      <img onClick={() => {
                                        history.push({
                                          pathname: `/profile/cardList/editCard/${item.card_id}`
                                        })
                                      }} src={iconEdit} />
                                      <span>Edit</span>
                                    </div>
                                  </div>
                                }
                            </div>
                          )
                        }) :
                        <div className="col-12 padding-rt">
                            <div style={{textAlign:'center', padding:'200px 0'}}>
                                <p>No cards available!</p>
                                {/* <p>Click on new payment to continue.</p> */}
                            </div>
                        </div>
                      }

                    </div>
                  </div>
                </div>
                {pathname !== '/profile/cardList' && selectedCard &&
                  <div class="comman-btn payment">
                    <button onClick={() => handleSelectedCardPay()}>Pay</button>
                  </div>
                }
              </div>
            </div>
          </section>
        </>
    )
}
